import { Box, IconButton, Link, Typography } from "@mui/material";
import { useCallback, useRef } from "react";
import UploadIcon from '@mui/icons-material/Upload';
import truncarString from "../../helpers/truncarString";
import ClearIcon from '@mui/icons-material/Clear';
import { enqueueSnackbar } from "notistack";

export default function UploadFileListItem({
    value,
    onChangeValue,
    label,
    error = false,
    hasBorder = true,
    filesExtension = ".pdf,.doc,.docx,.jpg,.jpeg,.png"
}: UploadFileListItemProps) {

    const fileInputRef = useRef<HTMLInputElement>(null);

    //funções manipuladoras
    const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const novoArquivo = event.target.files && event.target.files[0];
        if (novoArquivo) {
            if (novoArquivo.size <= 10 * 1024 * 1024) {
                onChangeValue(novoArquivo);
            } else {
                enqueueSnackbar("Arquivo excede o tamanho máximo de 10mb", { variant: "warning" })
                return
            }
        };
    }, [onChangeValue]);

    const handleRemoveFile = useCallback(() => {
        onChangeValue(null);
    }, [onChangeValue]);

    const handleClick = useCallback(() => {
        if (fileInputRef.current) fileInputRef.current.click();
    }, []);
    //

    const InputFile = () => (
        <>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept={filesExtension}
            />

            <Box
                p={1}
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                borderBottom={hasBorder ? "1px solid #ccc" : "unset"}
            >
                <Typography variant="subtitle2" color={error ? "error" : "unset"}>{label} {error ? 'Campo obrigatório' : ""}</Typography>

                <Box display="flex" alignItems="center" gap={2}>
                    {
                        !value &&
                        <IconButton aria-label="add" onClick={handleClick} color="primary">
                            <UploadIcon />
                        </IconButton>
                    }

                    {
                        (value && value.name) &&
                        <Link href="#" fontSize={14}>{truncarString(value.name, 30)}</Link>
                    }

                    {
                        value &&
                        <IconButton aria-label="delete" onClick={handleRemoveFile} color="error">
                            <ClearIcon />
                        </IconButton>
                    }
                </Box>
            </Box>
        </>
    )

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <InputFile />
        </Box>
    )
}

interface UploadFileListItemProps {
    value: File | null,
    onChangeValue: (arg: File | null) => void,
    label: string,
    error?: boolean,
    hasBorder?: boolean
    filesExtension?: string
}